module.exports = "/dist/images/it.b97e87f2.png";